import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useParams, useNavigate, useLocation } from "react-router-dom";

import "../pages/live.css"
import Layout from './Layout';


export default function Preview() {


  const [listEventItems, setListEventItems] = useState([])
  const [listTempEventItems, setListTempEventItems] = useState([])
  const [filterType, setFilterType] = useState("all")
  const [listEvents, setListEvents] = useState([])
  const [pagination, setPagination] = useState(25)

  let params = useParams();

  useEffect(() => {
    getEvents()

    axios.get('https://n2o2jjkzp1.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog')
      .then((res) => setListEvents(res.data.Items.filter(e => e.Id == params.id)))
      .catch(err => console.log(err))
  }, [])

  // useEffect(() => {
  //     setTimeout(function () {
  //         getEvents()
  //         console.log("updatedddddddddddd")
  //     }, 180000);
  // })
  const getEvents = () => {
    liveEventsFilter("all")
    let data = {
      event_data_by_id:params.id
  }
    axios.post('https://li47hu6fx7.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog-Events',data)
      .then((res) => {
        setListEventItems(res.data.sort(function (a, b) { return new Date(b.event_time) - new Date(a.event_time) }))
        setListTempEventItems(res.data.sort(function (a, b) { return new Date(b.event_time) - new Date(a.event_time) }))
        mppInstaFun()
        mppTwitterFun()

        // setListEventItems(res.data.Items.filter(e => e.event_id === params.id))
      })
      .catch(err => console.log(err))
    // axios.post('https://i5q7r5fa79.execute-api.ap-south-1.amazonaws.com/default/S3ImageUpload',data)
    // .then((res) => {
    //     console.log(res)
    //     setListEventItems(res.data.sort(function (a, b) { return new Date(b.event_time) - new Date(a.event_time) }))
    // })
    // .catch(err => console.error(err))
  }

  // setTimeout(()=>{
  //     getEvents()
  // },3000)

  const convertTime = (datetime) => {
    var hours = new Date(datetime).getHours();
    var minutes = new Date(datetime).getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = addZeroBefore(hours) + ':' + (minutes) + ' ' + ampm;
    return strTime;
  }

  const timeSince = (date) => {

    var seconds = Math.floor((new Date() - new Date(date)) / 1000);

    var interval = seconds / 31536000;

    if (interval > 1) {
      return Math.floor(interval) + " years ago";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months ago";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hr ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " min ago";
    }
    return Math.floor(seconds) + " sec ago";
  }

  const dateFormat = (datetime) => {
    const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    let date


    if (new Date().getFullYear() > new Date(datetime).getFullYear()) {
      date = month[new Date(datetime).getMonth()] + " " + new Date(datetime).getDate() + ", " + new Date(datetime).getFullYear()

    } else {
      date = month[new Date(datetime).getMonth()] + " " + new Date(datetime).getDate()

    }

    return date
  }

  function addZeroBefore(n) {
    return (n < 10 ? '0' : '') + n;
  }
  function createMarkup(items) {
    return { __html: items };
  }

  const liveEventsFilter = (filterType) => {

    setFilterType(filterType)


    let filter
    if (filterType === "all") {
      filter = listTempEventItems
    }
    else if (filterType === "photos") {
      filter = listTempEventItems.filter(e => e.event_imageurl)

    }
    else if (filterType === "videos") {
      filter = listTempEventItems.filter(e => e.event_videourl)

    }
    else if (filterType === "tweet") {
      filter = listTempEventItems.filter(e => !e.event_imageurl && !e.event_videourl)

    }
    setListEventItems(filter)

    mppInstaFun()
    mppTwitterFun()
    // console.log(filter)
  }
  const convertdate = (datetime) => {
    let date = new Date(datetime).getDate() + "-" + new Date(datetime).getMonth() + "-" + new Date(datetime).getFullYear()
    return date
  }

  const mppTwitterFun = () => {
    // window.twttr = (function (d, s, id) {
    //     var t, js, fjs = d.getElementsByTagName(s)[0];
    //     if (d.getElementById(id)) return; js = d.createElement(s); js.id = id;
    //     js.src = "https://platform.twitter.com/widgets.js"; fjs.parentNode.insertBefore(js, fjs);
    //     return window.twttr || (t = { _e: [], ready: function (f) { t._e.push(f) } });
    // }(document, "script", "twitter-wjs"));

    var s = document.createElement("script");
    s.src = "https://platform.twitter.com/widgets.js";
    s.async = true;
    document.getElementsByTagName('head')[0].appendChild(s);
    
}
const mppInstaFun = () =>{
    var s = document.createElement("script");
    s.src = "//platform.instagram.com/en_US/embeds.js";
    s.async = true;
    document.getElementsByTagName('head')[0].appendChild(s);
   
}


  console.log(listEvents)
  return (
    // <Layout>
    <div className="container">
      <div className="row">
        <div className="col-lg-9 mpp-width-856 mpp-story-full-section p-0">
          <div className="mpp-story-live-content-details">
            <div className="d-flex justify-content-between mt-4 flex-column flex-md-row align-items-md-end">
              <div className="mpp-story-live-date">
                {listEvents[0]?.status === "LIVE" ?
                  <p className="btn mpp-btn-danger english m-0">
                    LIVE UPDATES
                  </p> : ""}
              </div>
              <div className="mpp-story-live-filter mt-3 mt-md-0">
                <button className={`btn english mx-3 mpp-btn-stable`} onClick={() => getEvents()}><i className="mx-3 fas fa-redo"></i></button>
                <button className={`btn english ${filterType === "all" ? "mpp-btn-active" : "mpp-btn-stable"}`} onClick={() => liveEventsFilter("all")}>All</button>
                <button className={`btn english ${filterType === "photos" ? "mpp-btn-active" : "mpp-btn-stable"}`} onClick={() => liveEventsFilter("photos")}>Photos</button>
                <button className={`btn english ${filterType === "videos" ? "mpp-btn-active" : "mpp-btn-stable"}`} onClick={() => liveEventsFilter("videos")}>Videos</button>
                <button className={`btn english ${filterType === "tweet" ? "mpp-btn-active" : "mpp-btn-stable"}`} onClick={() => liveEventsFilter("tweet")}>Tweet</button>
              </div>
            </div>

            <div className="mpp-story-live-updates mt-3">
              {listEventItems.length ? listEventItems?.filter(e => e.status === "open").map((items, index) => (
                index < pagination ?
                  <div
                    className="
                    mpp-story-live-updates-news-content
                    d-flex
                    justify-content-between
                  "
                  key={index}
                  >
                    <div
                      className="
                      mpp-story-live-updates-time mpp-border-radius
                      d-flex
                      justify-content-center
                      align-items-center
                      text-center
                      
                    "
                    >
                      <p className="m-0 english">{convertTime(items.event_time)} <span style={{ fontSize: "10px" }}>(IST)</span>
                        <p className="m-0 english" style={{ fontSize: "12px" }}>{dateFormat(items.event_time)}</p></p>
                    </div>

                    <div
                      className="
                      mpp-story-live-updates-news mpp-border mpp-border-radius
                      
                      position-relative
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                    >
                      <div
                        className="
                        d-none d-sm-block
                        mpp-red-dot
                        position-absolute
                        top-0
                        start-0
                        translate-middle
                      "
                      ></div>
                      <div className="" style={{ width: "100%", padding: items.event_imageurl || items?.event_videourl ? "" : "20px" }}>


                        {items?.event_imageurl ? <img src={items?.event_imageurl} className="img-fluid mpp-border-radius" /> : ""}
                        {items?.event_videourl ? <div className='mpp-border-radius mpp-video-thumb-full mt-2' >

                          <iframe src={`https://cdn.jwplayer.com/players/${items.event_videourl}-dbzR9ypW.html`} allowFullScreen webkitAllowFullScreen mozAllowFullScreen style={{ top: "0px", right: "0px", bottom: "0px", left: "0px", width: "100%", height: "100%" }}></iframe>

                        </div>
                          : ""}

                        {items.event_audiourl ? <audio controls className="m-2">
                          <source src={items.event_audiourl} type="audio/ogg" />
                          <source src={items.event_audiourl} type="audio/mpeg" />
                          Your browser does not support the audio element.
                        </audio> : ""}
                        <div style={{ width: "100%", padding: items?.event_imageurl || items?.event_videourl ? "20px" : "" }}>
                          <div className="m-0 malayalam p-0" style={{ width: "100%" }} dangerouslySetInnerHTML={createMarkup(items.event_description)}></div>

                        </div>
                        {/* <div class="mpp-icons cursor">
                                                <i class="fas fa-share"></i>
                                            </div> */}
                      </div>
                    </div>
                  </div> : ""
              )) : ""}
            </div>

          </div>
          {listTempEventItems.length < pagination ? "" :
            <div className="d-flex justify-content-end mt-3">
              <p className="btn mpp-btn-stable" onClick={() => setPagination(pagination + 10)}>Load more..</p>
            </div>}
        </div>
        <div className="col-lg-3 p-0">

        </div>
      </div>

    </div>
    // </Layout>
  )
}
